export default __webpack_public_path__ + "static/media/avatar_112.f313af81.png";